<template>
  <v-dialog :value="immo !== undefined" fullscreen @keydown.esc="close">
    <v-card>
      <v-toolbar dense fixed>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="close" text small>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <!-- <v-img
        v-if="immo.info.thumb"
        :src="imageURL(immo.info.thumb.replace(/thumbnail/, 'scaled'))"
      ></v-img> -->
      <v-carousel
        v-if="images.length > 0"
        v-model="carousel"
        height="auto"
        hide-delimiters
        show-arrows-on-hover
      >
        <v-carousel-item
          v-for="image in images"
          :key="image.id"
          :src="image.scaled"
          max-width="1400"
        ></v-carousel-item>
      </v-carousel>

      <v-container v-if="images.length > 0" fluid>
        <v-row justify="center" dense>
          <v-col v-for="(image, i) in images" :key="image.id" cols="auto">
            <v-card @click="carousel = i" width="100px" raised="">
              <v-img :src="image.thumb" height="100px">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="grey lighten-2">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="text-right">
        <span class="grey--text mr-2">#{{ immo.meta.ref }}</span>
      </div>
      <v-card-title primary-title>
        <div class="headline">{{ immo.info.title }}</div>
      </v-card-title>

      <v-card-text class="subtitle-1 text-end">
        {{ immo.properties.price | formatPrice }}
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model.number="immo.properties.price"
              label="Price"
              readonly
            ></v-text-field>
            <v-text-field
              v-model.number="immo.properties.living"
              label="Living Area"
              readonly
            ></v-text-field>
            <v-text-field
              v-model.number="immo.properties.bedrooms"
              label="Bedrooms"
              type="number"
              readonly
            ></v-text-field>
            <v-text-field
              v-model.number="immo.properties.lawn"
              label="Lawn"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model.number="immo.properties.build"
              label="Build Year"
              readonly
            ></v-text-field>
            <v-text-field
              v-model.number="immo.properties.property"
              label="Property Area"
              readonly
            ></v-text-field>
            <v-text-field
              v-model.number="immo.properties.bathrooms"
              label="Bathrooms"
              type="number"
              readonly
            ></v-text-field>

            <v-text-field
              v-model.number="immo.properties.terrace"
              label="Terrace"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-chip v-if="immo.properties.sea_access" outlined label>
            <v-icon left>rowing</v-icon>
            Sea Access
          </v-chip>
          <v-chip v-if="immo.properties.sea_view" outlined label>
            <v-icon left>shopping_basket</v-icon>
            Sea View
          </v-chip>
          <v-chip v-if="immo.properties.pool" outlined label>
            <v-icon left>view_day</v-icon>
            Pool
          </v-chip>
          <v-chip v-if="immo.properties.golf" outlined label>
            <v-icon left>markunread_mailbox</v-icon>
            Golf
          </v-chip>
          <v-chip v-if="immo.properties.garage" outlined label>
            <v-icon left>store</v-icon>
            Garage
          </v-chip>
          <v-chip v-if="immo.properties.parking" outlined label>
            <v-icon left>settings_cell</v-icon>
            Parking
          </v-chip>
          <v-chip v-if="immo.properties.rental" outlined label>
            <v-icon left>money</v-icon>
            Rental Licence
          </v-chip>
          <v-chip v-if="immo.properties.investment" outlined label>
            <v-icon left>euro</v-icon>
            Investment
          </v-chip>
        </v-row>
      </v-card-text>

      <v-card-text class="ma-4 body-1">
        {{ immo.info.description }}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ImmoService from '@/services/immo.service'

export default {
  name: 'ImmoDialog',
  props: ['immo'],
  data() {
    return {
      images: [],
      carousel: 0
    }
  },

  methods: {
    close() {
      this.$emit('closed')
    }
  },

  // watch: {
  //   immo: {
  //     immediate: true,
  //     // deep: true,
  //     async handler() {
  //       if (this.immo === null) return
  //       const images = await ImmoService.getImages(this.immo.id)
  //       this.images = images.map(img => {
  //         return {
  //           id: img.id,
  //           scaled: `/images/${img.filename}`,
  //           thumb: `/images/${img.filename.replace(/scaled/, 'thumbnail')}`
  //         }
  //       })
  //     }
  //   }
  // },

  async mounted() {
    const images = await ImmoService.getImages(this.immo.id)
    this.images = images.map(img => {
      return {
        id: img.id,
        scaled: `/images/${img.filename}`,
        thumb: `/images/${img.filename.replace(/scaled/, 'thumbnail')}`
      }
    })
  }
}
</script>

<style></style>
